/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Billing_ResumeInputs */



/**
* | output |
* | --- |
* | "Resumed the plan" |
*
* @param {Activity_Billing_ResumeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_billing_resume = /** @type {((inputs?: Activity_Billing_ResumeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Billing_ResumeInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тариф возобновлён")
	return /** @type {LocalizedString} */ ("Resumed the plan")
});